import { useState, useEffect } from "react";
import {ApiUrl} from "../../ApiUrl"

const useFetchReligions = () => {
  const [religions, setReligions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch(`${ApiUrl.apiurl}RELIGION/GetAllReligion/`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Religion API Response:", data); 
        if (Array.isArray(data?.data)) {
          setReligions(data.data);
        } else {
          setReligions([]);
          setError("Invalid data format");
        }
      })
      .catch((error) => {
        console.error("Error fetching religions:", error);
        setError(error.message);
        setReligions([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { religions, loading, error };
};

export default useFetchReligions;
